import { Routes } from '@angular/router';
import { authGuard, dmsGuard, loginOverlayRedirectGuard } from './core/guards/auth.guard';
import { enforcementRoutes } from './modules/enforcement/enforcement.routes';
import { LandingComponent } from './shared/landing/landing.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', component: LandingComponent },
  {
    path: 'login',
    canActivate: [loginOverlayRedirectGuard],
    component: LandingComponent,
  },
  {
    path: 'documents',
    canActivate: [dmsGuard],
    canActivateChild: [dmsGuard],
    loadChildren: () => import('./modules/dms/documents.routes').then((m) => m.documentsRoutes),
  },
  {
    path: 'dms',
    canActivate: [dmsGuard],
    canActivateChild: [dmsGuard],
    loadChildren: () => import('./modules/dms/dms.routes').then((m) => m.dmsRoutes),
  },
  {
    path: 'enforcement',
    canActivate: [authGuard],
    children: enforcementRoutes,
  },
  { path: '**', redirectTo: '' },
];
